
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns",
      function () {
        return require("private-next-pages/campaigns/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns"])
      });
    }
  